import { useMediaQuery, useTheme, IconButton, Button, Typography } from '@mui/material';
import React from 'react'
import RightArrow from '../icons/RightArrow';

const BackButton = ({ backLabel = 'Back', backHandler }) => {
    if (!backHandler) {
        throw new Error('backHandler is required');
    }
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return <>{
        isMobile ? (
            <IconButton onClick={backHandler} aria-label="Back" sx={{ ml: -1, flexShrink: 0 }}>
                <RightArrow leftArrow />
            </IconButton >
        ) : (
            <Button type="text" onClick={backHandler} startIcon={<RightArrow leftArrow />} sx={{ flexShrink: 0 }}>
                <Typography variant={isMobile ? "body2" : "subtitle1"} sx={{ textTransform: 'none' }}>
                    {backLabel}
                </Typography>
            </Button>
        )}
    </>

}

export default BackButton
